import { GroupBase, MenuProps } from "react-select";
import { MenuPropsContext } from "./MenuPropsContext";

export function Menu<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ children, ...props }: MenuProps<Option, IsMulti, Group>) {
  return (
    <MenuPropsContext.Provider value={props as any as MenuProps}>
      {children}
    </MenuPropsContext.Provider>
  );
}